// $.toastr api - https://github.com/CodeSeven/toastr#toastr
// configure notifications
import toastr from 'toastr';

toastr.options = {
    positionClass: 'toast-bottom-center',
    preventDuplicates: true,
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: false,
    onclick: null,
    showDuration: '300',
    hideDuration: '2000',
    timeOut: '5000',
    extendedTimeOut: '3000',
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'fadeOut'
};

export default {
    notify ( ...msg ) {
        toastr.success?.( ...msg );
    },
    warn ( ...msg ) {
        toastr.warning?.( ...msg );
    },
    info ( ...msg ) {
        toastr.info?.( ...msg );
    },
    error ( ...msg ) {
        toastr.error?.( ...msg );
    },

    prompt ( fn ) {
        var args = [].slice.call( arguments, 1 ), self = this;

        $( 'body' ).upiDialog( upi.conf.GENERIC_SERVICE_ERROR, {
                'ok': (typeof fn === 'function')
                    ? function () {
                        fn.apply( self, args );
                    }
                    : null
            }, {className: 'formError'}
        );
    }
}
